<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
      <tr>
        <th colspan="4">
          <h5 class="text-center"><b>ESCOLARIDADE</b></h5>
        </th>
      </tr>

      <tr>
        <td colspan="2">
          SABE LER E ESCREVER?
          <b>{{ usuario.sabe_ler ?? '-' }}</b>
        </td>

        <td colspan="2">
          FREQUENTA ESCOLA OU CRECHE?
          <b>{{ usuario.frequenta_escola ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          NOME DA ESCOLA/COLÉGIO/FACULDADE:
          <b>{{ usuario.escola_nome ?? '-' }}</b>
        </td>

        <td colspan="2">
          A ESCOLA É LOCALIZADA NO MUNICÍPIO?
          <b>{{ usuario.escola_localizada_municipio ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          UF DA ESCOLA OU CRECHE:
          <b>{{ usuario.escola_uf ?? '-' }}</b>
        </td>

        <td colspan="2">
          MUNICÍPIO ONDE ESTÁ LOCALIZADA A ESCOLA:
          <b>{{ usuario.escola_municipio?.nome ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          CÓDIGO INEP DA ESCOLA:
          <b>{{ usuario.escola_inep ?? '-' }}</b>
        </td>

        <td colspan="2">
          ESTÁ ESTUDANDO?:
          <b>{{ usuario.esta_estudando ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          SÉRIE ESCOLAR/COLEGIAL/SUPERIOR?
          <b>{{ usuario.curso_frequenta ?? '-' }}</b>
        </td>

        <td colspan="2">
          ANO/SÉRIE QUE FREQUENTA?
          <b>{{ usuario.ano_serie_frequentou ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          <b>PARA A PESSOA QUE NÃO FREQUENTA ESCOLA, MAS JÁ FREQUENTOU</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          CURSO MAIS ELEVADO QUE FREQUENTOU, NO QUAL CONCLUIU PELO MENOS UMA SÉRIE?
          <b>{{ usuario.curso_frequentou ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          ÚLTIMO ANO/SÉRIE FREQUENTADO:
          <b>{{ usuario.ano_serie_frequentou ?? '-' }}</b>
        </td>

        <td colspan="2">
          O USUÁRIO CONCLUIU O CURSO?
          <b>{{ usuario.concluiu_curso ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          PRETENDE RETORNAR A ESTUDAR?
          <b>{{ usuario.pretende_retornar ?? '-' }}</b>
        </td>

        <td colspan="2">
          DIFICULDADE DE APRENDIZAGEM?
          <b>{{ usuario.dificuldade_aprendizagem ?? '-' }}</b>
        </td>
      </tr>

      <tr>
        <td colspan="4">
          OBSERVAÇÕES:
          <span v-html="usuario.observacoes"></span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["usuario"],
};
</script>